import { render } from "./FormRoofView.vue?vue&type=template&id=6ad856b8"
import script from "./FormRoofView.vue?vue&type=script&lang=js"
export * from "./FormRoofView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__